
import { PaletteColorOptions } from '@mui/material/styles';
import { ThemeMode } from 'config';
import { PalettesProps } from '@ant-design/colors';
import { PaletteThemeProps } from 'types/theme';

export function Theme11(colors: PalettesProps, mode: ThemeMode): PaletteThemeProps {
  const { grey } = colors;

  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  const contrastText = '#ffffff';

  let primaryColors = [
    '#E8F0FF', 
    '#C6DAFF', 
    '#A6C2F7', 
    '#7FA7E6', 
    '#527FCA', 
    '#0F2647',
    '#0C1F39', 
    '#09182D', 
    '#061221', 
    '#030A12' 
  ];

  if (mode === ThemeMode.DARK) {
    primaryColors = [
      '#061221',
      '#09182D', 
      '#0C1F39', 
      '#0F2647', 
      '#3A4F7A', 
      '#5471A3', 
      '#7F9BD1', 
      '#A9BDEA', 
      '#CFDBF7', 
      '#E9F1FF' 
    ];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    grey: greyColors
  } as any;
}
